/**
 * Early termination fee exceptions -- FAQ/help page content.
 * Source: "AIOpCo Docs & Templates/ETF Education And Buyout Promo Placement Spec.md" (Reba-CPO,
 * 2026-09-29), Section 3. Wording is Witherspoon-CLO's compliance/01_texas_disclosures.md Section 15,
 * verbatim (site-copy rules for Q2/Q3) or paraphrased only within Section 15's own constraint (Q1: never
 * publish a specific day count or blanket exception as a Texas-wide fact).
 *
 * This is the single source of truth for the three-exception explainer. The bill-check "Your Contract"
 * card (lib/billExplainTexts.js) and the Plans/PlanDetail inline fine-print links all point HERE instead of
 * repeating CLO's wording in three places -- if CLO revises this text, this is the only file that changes.
 * Components render these constants verbatim; nobody rewords them.
 */

export const EARLY_TERMINATION_FAQ_PATH = "/help/early-termination-fees";
export const ETF_EXCEPTIONS_INLINE_LINK_TEXT = "exceptions may apply →";

export const ETF_FAQ_H1 = "Early Termination Fees: What Actually Applies To You";

export const ETF_FAQ_INTRO =
  "Early termination fees (ETFs) are set out in your electricity contract, and Texas Public Utility " +
  "Commission rules limit when a provider may charge one. Below are the three situations people ask about " +
  "most. What applies to you depends on your contract and the rule, so check your Electricity Facts Label " +
  "(EFL) and Terms of Service.";

export const ETF_FAQ_QUESTIONS = [
  {
    id: "near-contract-end",
    question: "Can I switch near the end of my contract without paying a fee?",
    answer:
      "Some providers waive the early termination fee in the final stretch of a contract term. We have not " +
      "found a statewide rule that sets a day count, so the window, if a provider offers one, is in your " +
      "contract. Check your EFL and Terms of Service, or call your provider.",
  },
  {
    id: "moving",
    question: "What if I'm moving?",
    // CLO Text A (SEO_Copy_Rulings.md Section 3): safe whether or not the stronger reading holds.
    // Text B (the stronger "the provider may not charge you an early termination fee because of the move"
    // statement) stays UNPUBLISHED until the CLO [VERIFY] on 16 TAC 25.475(c)(2)(C) is closed. [VERIFY]
    answer:
      "Texas PUC rules (16 TAC §25.475) include a provision about early termination fees when a customer " +
      "relocates. It has conditions, such as giving your provider a forwarding address and, if asked, " +
      "reasonable evidence of the move. Read the rule and your Terms of Service, or call your provider, to " +
      "confirm how it applies to you.",
  },
  {
    id: "transfer-of-service",
    question: "Can I transfer my contract to a new address or a new occupant instead of paying the fee?",
    answer:
      "Some providers let you transfer your contract to a new occupant or a new address. Ask your provider; " +
      "we have not found a Texas rule that requires it.",
  },
];

export const ETF_FAQ_CLOSING =
  "If you are timing a move around a lease ending, check the rule and your provider's exact terms before " +
  "you decide. If anything on this page differs from the current rule or your contract, the rule and your " +
  "contract control.";

/** Visible Sources + review line (SEO_Copy_Rulings.md Section 3). Retrieval date = TSEO's read of the PDF, 2026-10-05. */
export const ETF_SOURCES = [
  {
    label: "16 TAC §25.475, Texas Public Utility Commission",
    url: "https://ftp.puc.texas.gov/public/puct-info/agency/rulesnlaws/subrules/electric/25.475/25.475.pdf",
    retrieved: "October 5, 2026",
  },
];
export const ETF_LAST_REVIEWED = "October 5, 2026";
